import React from "react"

export default function Blog037() {
  return (
    <section>
    <article>
    <h2>37. 01-17-2023</h2>
          <h3>Tutorial Menu</h3>
          <p>
          <strong>I created a website menu for my javascript tutorials</strong>
          <br /><br />
          I'm always looking for new ways to sharpen my abilities and keep up with the most recent technologies because I work as a software developer. Developing a Javascript tutorial menu website was one of my most recent endeavors.
          <br /><br />
          Currently, I am an intern at In The Zone, a company that specializes in developing cutting-edge software solutions. This internship has provided me with the opportunity to work on real-world projects and learn from experienced developers.
          <br /><br />
For my tutorial website, I wanted to create a resource that would be accessible to both beginners and more advanced programmers. The goal was to provide a wide range of tutorials that cover various aspects of Javascript development.
<br /><br />
So far, I have posted the first 12 tutorials on the website. These cover a variety of topics, including how to build your first HTML website, create a flexbox, host your website with GitHub, change colors with CSS, add text with HTML, add images with HTML, and more.
<br /><br />
The tutorials are designed to be easy to follow, with clear explanations and plenty of examples. I have also included code snippets and links to additional resources where appropriate.
<br /><br />
One of the things that I am particularly excited about with this project is the potential for it to grow over time. As I continue to learn and develop my skills, I plan to add more tutorials to the website and expand on existing ones.
<br /><br />
I am also open to feedback and suggestions from users. If there is a topic that you would like to see covered on the website, please feel free to contact me.
<br /><br />
Overall, I believe that this tutorial website will be a valuable resource for anyone looking to learn more about Javascript development.<a
className="text-blue-800 hover:text-blue-600 font-medium"
              href="https://javascript.ericpolley.com"
              title="Javascript Tutorials"
              target="_blank"
              rel="noopener noreferrer" 
            > I encourage you to check it out and see for yourself.</a>
<br /><br />


<br /><br />
Thank you for your time,
<br /><br />
Eric Polley<br />
Software Developer Intern at In The Zone





         
          </p>
          
          </article>

        <h4>Links</h4>
        <br />
        <ul>
        <li>
            <a
              href="https://javascript.ericpolley.com"
              title="Javascript Tutorials"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>Javascript Tutorial Website</p></strong></
            a>
          </li>
        
          <li>
            <a
              href="http://ericpolley.com"
              title="Check out my Portfolio!"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>Eric Polley's Website</p></strong></a
            >
          </li>
        </ul>
        </ section >
  )
}
